export default [{
  path: '/graphic',
  name: 'graphic',
  meta: {
    layout: 'main'
  },
  component: () => import('@/views/graphic/index')
}]
